import LinkToDocusaurus from '../LinkToDocusaurus'
import { managingSuites } from '../../docs-routes'

const LinkToSuitesState = () =>
  <LinkToDocusaurus path={managingSuites}>
    Learn more about Suites
  </LinkToDocusaurus>

export default LinkToSuitesState
